import React from 'react';
import { Box } from '@mui/material';
import { PinnacleTextField } from '../../../../../../components/PinnacleTextField';
import { E_FIELD_REQUIRED } from '../../../../../../utils/constants';
import { ExamByCodeFormData } from '../../../../hooks/useExamByCodeForm';

interface ExamInformationProps {
    touchedFields: Record<keyof ExamByCodeFormData, boolean>;
    onBlur: (field: keyof ExamByCodeFormData) => void;
    isSubmitting: boolean;
    formData: ExamByCodeFormData;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const ExamInformation: React.FC<ExamInformationProps> = ({
    touchedFields,
    onBlur,
    isSubmitting,
    formData,
    onChange
}) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <PinnacleTextField
                label="Examination Name"
                name="name"
                value={formData.name}
                onChange={onChange}
                fullWidth
                onBlur={() => onBlur('name')}
                error={touchedFields.name && !formData.name.trim()}
                helperText={
                    touchedFields.name && !formData.name.trim()
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
            />

            <PinnacleTextField
                label="Description"
                name="description"
                value={formData.description}
                onChange={onChange}
                multiline
                rows={5}
                fullWidth
                onBlur={() => onBlur('description')}
                error={touchedFields.description && !formData.description.trim()}
                helperText={
                    touchedFields.description && !formData.description.trim()
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
            />

            <PinnacleTextField
                label="Start Date"
                type="datetime-local"
                name="startDate"
                value={formData.startDate || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                onBlur={() => onBlur('startDate')}
                error={touchedFields.startDate && !formData.startDate}
                helperText={
                    touchedFields.startDate && !formData.startDate
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
            />

            <PinnacleTextField
                label="No. of Allowed Attempts"
                type="number"
                name="maxAttempts"
                value={formData.maxAttempts}
                onChange={onChange}
                fullWidth
                onBlur={() => onBlur('maxAttempts')}
                error={touchedFields.maxAttempts && !Number.isInteger(formData.maxAttempts) && formData.maxAttempts === 0}
                helperText={
                    touchedFields.maxAttempts && !Number.isInteger(formData.maxAttempts) && formData.maxAttempts === 0
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
                slotProps={{
                    htmlInput: {
                        min: 0,
                    },
                }}
            />

            <PinnacleTextField
                label="Timer"
                type="number"
                name="timer"
                value={formData.timer}
                onChange={onChange}
                fullWidth
                onBlur={() => onBlur('timer')}
                error={touchedFields.timer && !Number.isInteger(formData.timer) && formData.timer === 0}
                helperText={
                    touchedFields.timer && !Number.isInteger(formData.timer) && formData.timer === 0
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
                slotProps={{
                    htmlInput: {
                        min: 0,
                    },
                }}
            />

            <PinnacleTextField
                label="Grade Adjustment"
                type="number"
                name="rebaseValue"
                value={formData.rebaseValue}
                onChange={onChange}
                fullWidth
                onBlur={() => onBlur('rebaseValue')}
                error={touchedFields.rebaseValue && !Number.isInteger(formData.rebaseValue) && formData.rebaseValue === 0}
                helperText={
                    touchedFields.rebaseValue && !Number.isInteger(formData.rebaseValue) && formData.rebaseValue === 0
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
                slotProps={{
                    htmlInput: {
                        min: 0,
                    },
                }}
            />
        </Box>
    );
};


export default ExamInformation;
